import { cn } from '@/lib/cn.ts';

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  inset?: boolean;
};

/** Elevated surface: 1px hairline + subtle top sheen, no heavy drop shadow. */
export function Card({ className, inset, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-bg-elevated',
        'shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]',
        inset && 'p-5',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

type SectionHeaderProps = {
  title: string;
  count?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
};

/** Uppercase kicker header used atop tables, panels and list cards. */
export function CardHeader({ title, count, action, className }: SectionHeaderProps) {
  return (
    <header
      className={cn(
        'flex items-center justify-between gap-3 border-b border-border px-4 py-3',
        className,
      )}
    >
      <div className="flex items-baseline gap-2">
        <h2 className="kicker">{title}</h2>
        {count != null && <span className="mono text-[11px] text-text-faint tnum">{count}</span>}
      </div>
      {action}
    </header>
  );
}
